import React from 'react';
import PropTypes from 'prop-types';

const FormSelect = ({
	action,
	data,
	placeholder = '',
	disabled = false,
	error = '',
	id,
	label = '',
	name = '',
	required = false,
	value,
	isMultiSelect = false,
	fullWidth = false,
}) => (
	<>
		{label && (
			<label
				className="form-label"
				htmlFor={id}
			>
				{label}
				{required && <span className="font-color-theme-danger"> *</span>}
			</label>
		)}
		<div className={`form__container ${fullWidth ? 'is-full-width' : ''}`}>
			<select
				className={`form-select ${error ? 'error' : ''} ${isMultiSelect && 'is-multiselect'} ${fullWidth ? 'is-full-width' : ''}`}
				disabled={disabled}
				id={id}
				name={name}
				onChange={action}
				value={value || placeholder}
				multiple={isMultiSelect}
			>
				{placeholder && (
					<option value="" selected>
						{placeholder}
					</option>
				)}
				{data.map(option => (
					<option key={option.id} value={option.value}>
						{option.text}
					</option>
					))}
			</select>
		</div>
		{error && (
			<p className="font-color-theme-danger">
				{error}
			</p>
		)}
	</>
);

export default FormSelect;

FormSelect.propTypes = {
	action: PropTypes.func.isRequired,
	data: PropTypes.arrayOf(
		PropTypes.shape({
			id: PropTypes.oneOfType(
				[PropTypes.string, PropTypes.number],
			),
			text: PropTypes.string,
			value: PropTypes.oneOfType(
				[PropTypes.string, PropTypes.number, PropTypes.array],
			),
		}),
	).isRequired,
	placeholder: PropTypes.string,
	disabled: PropTypes.bool,
	error: PropTypes.string,
	id: PropTypes.string.isRequired,
	label: PropTypes.string,
	name: PropTypes.string,
	required: PropTypes.bool,
	value: PropTypes.oneOfType(
		[PropTypes.string, PropTypes.number, PropTypes.array],
	).isRequired,
	isMultiSelect: PropTypes.bool,
	fullWidth: PropTypes.bool,
};
